import { createGlobalStyle } from 'styled-components';
import Fonts from './fonts';
import FontStyles from './FontStyles';
import BaseStyles from './BaseStyles';
import TransitionStyles from './TransitionStyles';
import PrismStyles from './PrismStyles';

const GlobalStyle = createGlobalStyle`
  ${Fonts};

  ${FontStyles};

  :root {
    --john-bg-intense: #020c1b;
    --john-bg-moderate: #0a192f;
    --john-overlay: #80d8ff;
    --john-bg-mild: #172a45;
    --john-bg-mildest: #303C55;
    --john-bg-shadow: rgba(2, 12, 27, 0.7);
    --john-text-moderate: #8892b0;
    --john-text-mild: #a8b2d1;
    --john-text-mildest: #ccd6f6;
    --john-text-intense: #e6f1ff;
    --john-text-pretty: #80d8ff;
    --john-photo-overlay: #80d8ff;
    --john-text-pretty-shadow: rgba(128, 216, 255, 0.1);
    --john-nav-color: rgba(10, 25, 47, 0.85);
    --john-title-overlay: rgba(10, 25, 47, 0.7);
    --john-bg-overlay: #0a192f;
    --john-tint-color: 10, 25, 47;
    --underline-offset: 0.37em;
    --language: 'en';

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 200px;
    &:lang(ko) {
      --tab-width: 120px;
    }

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }

  ${BaseStyles};

  ${TransitionStyles};

  ${PrismStyles};
`;

export default GlobalStyle;
